module.exports = __webpack_public_path__ + "static/media/transaction-success.349f3dca.svg";